import React from 'react';

import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { ASSIGN_TRANSACTION_TO_CONTRACT } from 'src/store/actions/transactionActions';
import StepOne from './StepOne';
import FinalStep from './FinalStep';

const CurrentStep = ({
  activeStep,
  data,
  onNext,
  onBack,
  onSubmit,
  onCloseForm,
  resetRef
}) => {
  const loading = useSelector(
    isLoadingSelector([ASSIGN_TRANSACTION_TO_CONTRACT.action])
  );

  if (activeStep === 0) {
    return (
      <StepOne
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        onCloseForm={onCloseForm}
        resetRef={resetRef}
      />
    );
  }

  return (
    <FinalStep
      data={data}
      loading={loading}
      handleBack={onBack}
      handleSubmit={onSubmit}
      resetRef={resetRef}
    />
  );
};

CurrentStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
  data: PropTypes.any.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCloseForm: PropTypes.func.isRequired,
  resetRef: PropTypes.any.isRequired
};

export default CurrentStep;
